export default "__VITE_ASSET__DECk$9BP__"